import script from "./RegistrationBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./RegistrationBlock.vue?vue&type=script&setup=true&lang=js"

import "./RegistrationBlock.vue?vue&type=style&index=0&id=6ae99567&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ae99567"]])

export default __exports__